// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header___1ERsu","image":"Header__image___1XVTe","close-button":"Header__close-button___3etQM"};